import { RETURN_TO_WEBVIEW_FIRST_TIME } from '../mutation-types';

const state = {

    returnToWebviewFirstTime: false

};

type TWebViewState = typeof state;

const mutations = {

    [ RETURN_TO_WEBVIEW_FIRST_TIME ]( state: TWebViewState, flag: boolean ): void {

        state.returnToWebviewFirstTime = flag;

    }

};

export default {

    state,
    mutations

};
